/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Attributes_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Attributes failed to paste." |
*
* @param {Paste_Attributes_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_attributes_failed_toast = /** @type {((inputs?: Paste_Attributes_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Attributes_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Echec du collage des attributs.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Attribute konnten nicht eingefügt werden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile incollare gli attributi.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось вставить атрибуты.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudieron pegar los atributos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("属性粘贴失败。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("属性を貼り付けることができませんでした。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एट्रिब्यूट पेस्ट करने में विफल रहे।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Os atributos não puderam ser colados.")
	return /** @type {LocalizedString} */ ("Attributes failed to paste.")
});